module.exports = __webpack_public_path__ + "img/17.2dd356c3.jpg";